import {
  SingleSelectionConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const TransparentImageAnnotationSurveyConfig = (options) => {
  const { i18n } = options;

  return {
    featureArea: 'TransparentImageAnnotationSurvey',
    style: {
      root: {
        minWidth: 600,
        maxWidth: 600,
      },
    },
    others: {
      isUserInitiatedSurvey: true,
    },
    questions: [
      {
        isRequired: true,
        Type: SingleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Why do you want to delete the image?')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('The image isn\'t relevant to my ad.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('The image contains sensitive or inappropriate content.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('The image is not specific to my brand.')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('The image is low quality.')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('I don\'t want to add images to my ad.')),
          },
          {
            key: 'q1o6',
            hasInput: true,
            text: i18n.getString(_TL_('Other (please elaborate below).')),
          },
        ],
        data: {
        },
      },
    ],
  };
};
